import type { ExteriorFinish, FabricColor, PotStyle, WoodFinish } from "./CatalogUtils";

/**
 * Translating the catalogue's words into the art's words.
 *
 * The two vocabularies grew up apart, so they disagree in small ways: the catalogue writes
 * "painted pine" where the art writes `painted_pine`, and it names fabric after the village
 * palette where the art names it after plain colours. Everything the catalogue can say is
 * accounted for here, and a `bridge.test.ts` case fails if that stops being true.
 */

const WOOD: Record<string, WoodFinish> = {
  oak: "oak",
  walnut: "walnut",
  "painted pine": "painted_pine"
};

const FABRIC: Record<string, FabricColor> = {
  cream: "cream",
  moss: "green",
  clay: "red",
  bluebell: "blue",
  marigold: "yellow"
};

const POT: Record<string, PotStyle> = {
  terracotta: "terracotta",
  stone: "stone",
  painted: "painted"
};

const FINISH: Record<string, ExteriorFinish> = {
  new: "new",
  weathered: "weathered"
};

export function toWoodFinish(value: string | undefined): WoodFinish {
  return (value === undefined ? undefined : WOOD[value]) ?? "oak";
}

export function toFabricColor(value: string | undefined): FabricColor {
  return (value === undefined ? undefined : FABRIC[value]) ?? "cream";
}

export function toPotStyle(value: string | undefined): PotStyle {
  return (value === undefined ? undefined : POT[value]) ?? "terracotta";
}

export function toExteriorFinish(value: string | undefined): ExteriorFinish {
  return (value === undefined ? undefined : FINISH[value]) ?? "new";
}

/** Every catalogue word this module knows, for the test that guards against drift. */
export const VARIANT_VOCABULARY = { wood: WOOD, fabric: FABRIC, pot: POT, finish: FINISH } as const;
